import { IInitialState } from '../TradeIn/interfaces/state';
import produce from 'immer';
import {
    GET_TRADE_IN_DEVICES_FAILED,
    GET_TRADE_IN_DEVICES_SUCCESS,
    GET_TRADE_IN_DEVICES,
    SET_SUGGEST_FIELD_VALUE,
    SET_DEFAULT_STATE,
    SET_TRADE_IN_DEVICE,
    DELETE_SELECTED_TRADE_IN_DEVICE,
    TOGGLE_TRADE_IN_SWITCH,
} from './constants';
import { TradeInAction } from './actions';
/**
 * Initial state
 */
export const initialState: IInitialState = {
    loading: false,
    payload: null,
    hasError: false,
    tradeInSwitch: false,
    suggestFieldValue: '',
    selectedDeviceId: null,
    tauschbonus: false,
};

/**
 * Hardware overview reducer
 * @param state
 * @param action
 */
const tradeInReducer = (state: IInitialState = initialState, action: TradeInAction) =>
produce(state, (draft: IInitialState) => {
    switch (action.type) {
        case SET_DEFAULT_STATE:
            draft.tradeInSwitch = action.tradeInSwitch;
            break;
        case GET_TRADE_IN_DEVICES:
            draft.loading = true;
            break;
        case GET_TRADE_IN_DEVICES_SUCCESS:
            draft.payload = action.payload;
            draft.loading = false;
            draft.hasError = false;
            break;
        case GET_TRADE_IN_DEVICES_FAILED:
            draft.loading = false;
            draft.hasError = true;
            draft.payload = null;
            break;
        case SET_SUGGEST_FIELD_VALUE:
            draft.suggestFieldValue = action.suggestFieldValue;
            break;
        case TOGGLE_TRADE_IN_SWITCH:
            draft.tradeInSwitch = typeof action.force === 'boolean' ? action.force : !state.tradeInSwitch;
            break;
        case SET_TRADE_IN_DEVICE:
            draft.selectedDeviceId = action.selectedDeviceId;
            break;
        case DELETE_SELECTED_TRADE_IN_DEVICE:
            draft.selectedDeviceId = null;
            draft.suggestFieldValue = '';
            draft.payload = null;
            break;
    }
 });

export default tradeInReducer;
